module.exports = __webpack_public_path__ + "img/icon-up.f37e677d.svg";